export default "__VITE_ASSET__DU9i0nP2__"